import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';

import HelpButton from '../help/HelpButton';
import ColorContext from '../../context/ColorContext';

type Props = {
  title: string | React.ReactNode;
  onHelp?: () => void;
}

const Heading: React.FC<Props> = ({ title, onHelp }: Props) => {
  const color = useContext(ColorContext);
  return (
    <Box
      display="flex"
      className="reset-margin"
      sx={[
        () => {
          switch (color) {
            case 'secondary':
              return { backgroundColor: 'secondary.main' };
            case 'tertiary':
              return { backgroundColor: 'tertiary.main' };
            default:
              return { backgroundColor: 'primary.main' };
          }
        },
        {
          color: 'primary.contrastText',
          p: 2,
        },
      ]}
    >
      <Typography variant="h5" component="h5">{title}</Typography>
      {
        !!onHelp
        && (
          <HelpButton
            onClick={(): void => onHelp()}
          />
        )
      }
    </Box>
  );
};

export default Heading;
